import React, { useMemo } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
interface PnLChartProps {
  timeRange: string;
}
const CustomTooltip = ({
  active,
  payload
}: any) => {
  if (!active || !payload || !payload.length) return null;
  const data = payload[0].payload;
  const value = payload[0].value;
  const sign = value >= 0 ? '+' : '';
  return <div style={{
    background: 'rgba(20, 22, 32, 0.65)',
    backdropFilter: 'blur(32px) saturate(180%)',
    WebkitBackdropFilter: 'blur(32px) saturate(180%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    borderRadius: '28px',
    padding: '16px 20px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.08)'
  }} data-id="element-124">
      <div style={{
      color: '#9CA3AF',
      fontSize: '11px',
      marginBottom: '8px',
      letterSpacing: '0.05em',
      fontWeight: '400',
      textTransform: 'uppercase'
    }} data-id="element-125">
        {data.timestamp}
      </div>
      <div style={{
      color: '#FFFFFF',
      fontSize: '28px',
      fontWeight: '300',
      letterSpacing: '-0.02em'
    }} data-id="element-126">
        P&L: {sign}$
        {Math.abs(value).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })}
      </div>
    </div>;
};
export function PnLChart({
  timeRange
}: PnLChartProps) {
  const data = useMemo(() => {
    const result = [];
    let currentValue = 0;
    const now = new Date();
    for (let i = 30; i >= 0; i--) {
      const date = new Date(now);
      date.setDate(date.getDate() - i);
      if (i === 30) {
        currentValue = 0;
      } else if (i === 0) {
        currentValue = 2847.32;
      } else {
        const change = (Math.random() - 0.4) * 200;
        currentValue += change;
      }
      result.push({
        time: date.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric'
        }),
        timestamp: date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        }),
        value: currentValue
      });
    }
    return result;
  }, [timeRange]);
  return <div className="glass-border rounded-[20px] p-6 h-[400px] flex flex-col" data-id="element-127">
      <div className="flex items-center justify-between mb-6" data-id="element-128">
        <h3 className="text-sm font-heading text-text-primary" data-id="element-129">
          Cumulative P&L
        </h3>
      </div>

      <div className="flex-1 w-full" style={{
      overflow: 'visible'
    }} data-id="element-130">
        <ResponsiveContainer width="100%" height="100%" data-id="element-131">
          <AreaChart data={data} margin={{
          top: 10,
          right: 10,
          left: 0,
          bottom: 0
        }} style={{
          overflow: 'visible'
        }} data-id="element-132">
            <defs data-id="element-133">
              <linearGradient id="pnlColorValue" x1="0" y1="0" x2="0" y2="1" data-id="element-134">
                <stop offset="5%" stopColor="#8B5CF6" stopOpacity={0.2} data-id="element-135" />
                <stop offset="95%" stopColor="#8B5CF6" stopOpacity={0} data-id="element-136" />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#2B3139" vertical={false} opacity={0.3} data-id="element-137" />
            <XAxis dataKey="time" axisLine={false} tickLine={false} tick={{
            fill: '#848E9C',
            fontSize: 11
          }} dy={10} minTickGap={30} data-id="element-138" />
            <YAxis domain={[-200, 3200]} axisLine={false} tickLine={false} tick={{
            fill: '#848E9C',
            fontSize: 11
          }} tickFormatter={val => {
            if (val === 0) return '$0';
            if (Math.abs(val) < 1000) return `$${val}`;
            return `$${(val / 1000).toFixed(1)}K`;
          }} dx={-10} data-id="element-139" />
            <Tooltip content={<CustomTooltip data-id="element-141" />} wrapperStyle={{
            zIndex: 9999,
            pointerEvents: 'none'
          }} cursor={{
            stroke: '#8B5CF6',
            strokeWidth: 1,
            strokeDasharray: '4 4'
          }} data-id="element-140" />
            <Area type="monotoneX" dataKey="value" stroke="#8B5CF6" strokeWidth={2} fillOpacity={1} fill="url(#pnlColorValue)" animationDuration={1000} animationEasing="ease-in-out" data-id="element-142" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>;
}